import { handleActions } from "redux-actions";
import { PRODUCT_MEDIA } from "constants/action-types";
// eslint-disable-next-line import/no-duplicates
import { updateStateActions, progressActions, fetchActions, updateProgressActions } from "./base-reducers";
// eslint-disable-next-line import/no-duplicates
import { initialBaseState, IBaseStoreState, IFetchStoreState, IUpdateStoreState } from "./base-reducers";
import { IAsset } from "constants/assets";
import { I360Manifest } from "constants/product-media";
import { ICoreMediaAssets } from "constants/media-asset";

// prettier-ignore
export interface IMediaState extends IUpdateStoreState<IAsset> {
    isUploading: boolean;
}

// prettier-ignore
export type IMediaAssetsState = IFetchStoreState<ICoreMediaAssets> & IUpdateStoreState<ICoreMediaAssets>;

export type IMediaManifestState = IFetchStoreState<I360Manifest>;

const initialState = {
    ...initialBaseState,
    isUploading: false,
    isUpdating: false,
};

export const productMedia = handleActions<IMediaState>(
    {
        ...progressActions<IMediaState, IBaseStoreState<IMediaState> & { isUploading: boolean }>(
            PRODUCT_MEDIA.UPLOAD,
            "isUploading"
        ),
        ...updateProgressActions<IMediaState>(PRODUCT_MEDIA.MUTATE),
        ...updateStateActions<IMediaState>(PRODUCT_MEDIA),
        [PRODUCT_MEDIA.RESET]: (): IMediaState => initialState,
    } as any,
    initialState
);

export const productMediaAssets = handleActions<IMediaAssetsState>(
    {
        ...updateProgressActions<IMediaAssetsState>(PRODUCT_MEDIA.MEDIA_ASSETS.MUTATE),
        ...fetchActions<IMediaAssetsState>(PRODUCT_MEDIA.MEDIA_ASSETS.FETCH),
        [PRODUCT_MEDIA.MEDIA_ASSETS.RESET]: (): IMediaAssetsState => initialBaseState,
    } as any,
    initialState
);

// prettier-ignore
export const mediaManifest = handleActions<IMediaManifestState>(
    fetchActions<I360Manifest>(PRODUCT_MEDIA.IMAGE_360.MANIFEST) as any,
    initialBaseState
);
